
    import { Vue, Component, Inject } from 'vue-property-decorator'
    import { LogoutCommand } from '../commands/logout.command'
    import { NotificationDispatcher } from '@/app/common/services/notification-dispatcher.service'

    @Component
    export default class Logout extends Vue {
        @Inject() logoutCommand!: LogoutCommand
        @Inject() notificationDispatcher!: NotificationDispatcher

        async created() {
            await this.logoutCommand.run()
            await this.$router.push({ name: 'login' })
            await this.notificationDispatcher.success(this.$t('portal.general_notifications.logout_notification').toString())
            }
    }
